import Vue from 'vue';
import { MutationTree } from 'vuex';
import { EssayTheme, EssayState, EvaluationEssay } from './state';

const mutations: MutationTree<EssayState> = {
  SET_ESSAY_THEME(state, essayTheme: EssayTheme) {
    state.essayTheme = essayTheme;
  },
  SET_AVAILABLE_ESSAY_THEMES(state, availableEssayThemes: EssayTheme[]) {
    state.availableEssayThemes = availableEssayThemes;
  },
  SET_ESSAY(state, essay: EvaluationEssay) {
    state.essay = { ...state.essay, ...essay };
  },
};

export default mutations;
